import type { AppDispatch, RootState, store } from '@appStore/store'
import type { ActionCreatorsMapObject, AsyncThunk } from '@reduxjs/toolkit'

import { bindActionCreators } from '@reduxjs/toolkit'
import { useMemo } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'

const useAppDispatch = useDispatch.withTypes<AppDispatch>()
const useAppSelector = useSelector.withTypes<RootState>()

const useActionCreators = <Actions extends ActionCreatorsMapObject>(
	actions: Actions
): BoundActions<Actions> => {
	const dispatch = useAppDispatch()

	// biome-ignore lint/correctness/useExhaustiveDependencies: dispatch is stable
	return useMemo(() => bindActionCreators(actions, dispatch), [])
}

type BoundActions<Actions extends ActionCreatorsMapObject> = {
	[key in keyof Actions]: Actions[key] extends AsyncThunk<any, any, any>
		? BoundAsyncThunk<Actions[key]>
		: Actions[key]
}

type BoundAsyncThunk<Thunk extends AsyncThunk<any, any, any>> = (
	...args: Parameters<Thunk>
) => ReturnType<ReturnType<Thunk>>

const useAppStore = useStore as () => typeof store

export { useActionCreators, useAppDispatch, useAppSelector, useAppStore }
